await themeComponent(theme.components['mc-element'], false);

class McHeader extends McElement {
  constructor() {
    super();
    this.lastScrollState = null;
    this.scrollThreshold = 60;
    this._boundHandleScroll = this.handleScroll.bind(this);
    this._boundInitial = this.applyInitialScrollState.bind(this);
  }

  connectedCallback() {
    // Initial state
    this.lastScrollState = window.scrollY > this.scrollThreshold ? 'scrolled' : 'top';
    this.applyInitialScrollState();

    // Re-check after the DOM and assets settle (fonts/images can change header height)
    document.addEventListener('DOMContentLoaded', this._boundInitial, { once: true });
    window.addEventListener('load', this._boundInitial, { once: true });

    // Scroll listener
    window.addEventListener('scroll', this._boundHandleScroll, { passive: true });

    this.addEventListener('mouseover', () => { if (this.classList.contains('pretender')) this.handleCursor(false); });
    this.addEventListener('click',    () => { if (this.classList.contains('pretender')) this.handleCursor(false); });
    this.addEventListener('mouseleave', () => { if (this.classList.contains('pretender')) this.handleCursor(true); });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._boundHandleScroll);
    // The {once:true} listeners auto-remove themselves
  }

  applyInitialScrollState() {
    const isScrolled = window.scrollY > this.scrollThreshold;
    this.classList.toggle('scroll', isScrolled);
    document.body.classList.toggle('scroll', isScrolled);
    this.handleTransparency(!isScrolled);
  }

  handleScroll() {
    const isScrolled = window.scrollY > this.scrollThreshold;
    if (isScrolled && this.lastScrollState !== 'scrolled') {
      this.classList.add('scroll');
      document.body.classList.add('scroll');
      this.lastScrollState = 'scrolled';
      this.handleTransparency(false);
    } else if (!isScrolled && this.lastScrollState !== 'top') {
      this.classList.remove('scroll');
      document.body.classList.remove('scroll');
      this.lastScrollState = 'top';
      this.handleTransparency(true);
    }
  }

  handleCursor = (toggle) => {
    const menus = this.querySelectorAll('.megamenu-offcanvas');
    const isOpen = Array.from(menus).some(m => m.classList.contains('mc-active'));
    if (this.dataset.transparent === undefined) return;

    if (toggle && !isOpen) {
      this.classList.remove(this.dataset.sc);
      this.classList.add(this.dataset.sctr);
    } else {
      this.classList.remove(this.dataset.sctr);
      this.classList.add(this.dataset.sc);
    }
  };

  handleTransparency = (toggle) => {
    const menus = this.querySelectorAll('.megamenu-offcanvas');
    const isOpen = Array.from(menus).some(m => m.classList.contains('mc-active'));
    if (this.dataset.transparent === undefined) return;

    if (toggle && !isOpen) {
      this.classList.remove(this.dataset.sc);
      this.classList.add(this.dataset.sctr);
      this.classList.add('pretender');
    } else {
      this.classList.remove(this.dataset.sctr);
      this.classList.remove('pretender');
      this.classList.add(this.dataset.sc);
    }
  };
}

if (!window.customElements.get('mc-header')) {
  window.customElements.define('mc-header', McHeader);
}
window.McHeader = McHeader;
